import { localStorageAtom } from "./local-storage-atom"
import * as L from "lonna"

export type Tool = "pan" | "select" | "connect" | "note" | "container" | "text" | "line" | "embed" | "draw" | "table"
export type ControlSettings = {
    tool: Tool
    defaultTool?: Tool
}

export type ToolController = ReturnType<typeof ToolController>

export function ToolController() {
    const controlSettings = localStorageAtom<ControlSettings>("controlSettings", {
        tool: "select", // drag on empty canvas = rubber-band select; pan with Space, middle mouse or the Pan tool
    })
    const tool = L.atom(L.view(controlSettings, "tool"), (t) => {
        controlSettings.modify((s) => ({
            tool: t,
            defaultTool: t === "pan" || t === "select" ? t : s.defaultTool,
        }))
    })
    const defaultTool = L.view(controlSettings, (s) => s.defaultTool || "select")

    const useDefaultTool = () => {
        tool.set(defaultTool.get())
    }

    // Temporary tool (e.g. hold Space to pan): bypasses the `tool` setter so defaultTool isn't clobbered
    let toolBeforeTemporary: Tool | null = null
    const setTemporaryTool = (t: Tool) => {
        if (toolBeforeTemporary !== null) return
        toolBeforeTemporary = tool.get()
        controlSettings.modify((s) => ({ ...s, tool: t }))
    }
    const restoreTool = () => {
        if (toolBeforeTemporary === null) return
        const t = toolBeforeTemporary
        toolBeforeTemporary = null
        controlSettings.modify((s) => ({ ...s, tool: t }))
    }

    return {
        controlSettings,
        tool,
        useDefaultTool,
        setTemporaryTool,
        restoreTool,
    }
}
